import React from 'react'
import { interpolate } from '../utils/proposalVariables'
import { getRichBodyHtml, interpolateRichHtml } from '../utils/introRichText'

const NotesDetails = ({ data, variables }) => {
  const showTitle = data?.showTitle !== false
  const title = interpolate(data?.title || 'Notes & Details', variables)
  const bodyHtml = interpolateRichHtml(getRichBodyHtml(data), variables)

  return (
    <div className="proposal-section proposal-notes">
      {showTitle && (
        <>
          <div className="proposal-section__headline">{title}</div>
          <div className="proposal-section__accent-line" />
        </>
      )}
      {bodyHtml && (
        <div
          className="proposal-section__body proposal-rich-text proposal-notes__body"
          dangerouslySetInnerHTML={{ __html: bodyHtml }}
        />
      )}
    </div>
  )
}

export default NotesDetails
